/* eslint-disable eqeqeq */
import moment from 'moment';
import { Pages, declension, getUserAvatar } from '../../../utils/Utils';
import { getCookie } from '../../../utils/CookieHelper';

function CourseGroupCallItem(props) {
    const item = props.item
    const link = Pages.course + "?id=" + item._id
    const userItem = item.creator
    const course_date = moment(item.course_date).utc().local().format("DD.MM.YY")
    const course_date_end = moment(item.course_date_end).utc().local().format("DD.MM.YY")
    const mainScreenStyle = {margin : '8px 16px 2px 0', minWidth : '242px', borderRight: '4px solid #dee4ef'}

    return(
        <a rel="noreferrer" href={link} target="_blank">
            <div style={mainScreenStyle} className={"planned_item hover planned_ads_profile_item"}>
                <div className="planned_item_just">
                    <div className="planned_item_date">{"Курс · " + item.sozvon_by_links + " " + declension(item.sozvon_by_links, "встреча", "встречи", "встреч")}</div>
                    {/* {is_group_call && <div>
                        {!item.is_open ?
                        <div></div> 
                            :
                        isNotPaid ? 
                        <div className="planner_item_not_paid">не оплачено</div> 
                        :
                        <div className="planned_item_date">{item.price ? item.price : "0"}₽</div>}
                        
                    </div>} */}
                     <div className="planned_ads_price">{item.price ? item.price : "0"}₽</div>
                </div>
                <div className="planned_item_just">
                    <div style={{minHeight : '57px'}}>
                        <div className="planned_item_name">
                            <div className='planned_item_name_span'>{item.course_name}</div>
                        </div>
                        <div>
                            <div className="planned_ads_name_desc">{"Группа · " + item.client_vk_caller_ids_accepted + " чел."}</div>
                            <div className='planned_ads_name_desc'>{course_date + " - " + course_date_end}</div>
                        </div>
                    </div>
                    <img alt="" src={getUserAvatar(userItem)} className="planned_ads_item_avatar"/>
                </div>
                <div className='planned_ads_item_join'>Узнать детали</div>
            </div>
        </a>
    )
}
export default CourseGroupCallItem;
